import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createItemCategory,
  findAllActiveItemCategory,
  getAllItemCategory,
  getItemCategoryById,
  updateItemCategory,
} from "./services/itemcategory.services";
import {
  clearItemCategoryDetails,
  closeItemCategoryDrawerOpen,
} from "./itemcategorySlice";
import { Typography } from "@progress/kendo-react-common";

const CreateItemCategory: React.FC = () => {
  const formLoading = useAppSelector((state) => state.itemCategory.formLoading);
  const ItemCategoryDetail = useAppSelector(
    (state) => state.itemCategory.ItemCategoryDetail
  );
  const ItemGUID = useAppSelector((state) => state.muidrawer.data);
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);
  const itemCategoryDrawerOpen = useAppSelector(
    (state) => state.itemCategory.itemCategoryDrawerOpen
  );

  useEffect(() => {
    return () => {
      dispatch(clearItemCategoryDetails());
      if (itemCategoryDrawerOpen) {
        dispatch(closeItemCategoryDrawerOpen());
      } else {
        dispatch(closed());
      }
    };
  }, []);

  useEffect(() => {
    if (ItemGUID && !itemCategoryDrawerOpen) {
      dispatch(getItemCategoryById(ItemGUID));
    }
  }, [ItemGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!ItemGUID ) {
        const payload = {
          category_name: values.category_name,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createItemCategory(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (itemCategoryDrawerOpen) {
            dispatch(closeItemCategoryDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearItemCategoryDetails());
          isIndirect || itemCategoryDrawerOpen
            ? dispatch(findAllActiveItemCategory())
            : dispatch(getAllItemCategory());
        }
      } else {
        const payload = {
          category_guid: ItemGUID,
          category_name: values.category_name,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateItemCategory(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (itemCategoryDrawerOpen) {
            dispatch(closeItemCategoryDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearItemCategoryDetails());
          isIndirect || itemCategoryDrawerOpen
            ? dispatch(findAllActiveItemCategory())
            : dispatch(getAllItemCategory());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    if (itemCategoryDrawerOpen) {
      dispatch(closeItemCategoryDrawerOpen());
    } else {
      dispatch(closed());
    }
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={ItemCategoryDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem>
              <Typography.h4 className="m-0">
                {ItemGUID ? "Update Product Category" : "Add Product Category"}
              </Typography.h4>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="category_name"
                label="Product Category"
                placeholder="i.e. Gold Jewellery"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={ItemGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateItemCategory;
